// extracted by mini-css-extract-plugin
export default {"wrapper":"header_wrapper__zSLJp","hero_text":"header_hero_text__6I27p","box_con":"header_box_con__UF6QR","red_line":"header_red_line__9-Xql","head1":"header_head1__bAxDl"};